<template>
<div class="export-infections-data">
  <h2>Infections «{{dataset}}»</h2>
  <alert type="info">
    <p><strong>Attention !</strong></p>
    <p>
      Les infections sont extraites des fiches <strong>validées</strong>
      des protocoles bactADI, expADI, reaInfADI, neoInfADI et diaInfADI.
    </p>
    <p>
      Les infections sont téléchargées au <strong>format CSV</strong>.
    </p>
  </alert>
  <btn size="lg"
       class="export-button"
       type="success"
       @click="exportInfections('bact')">
    Bactériémies
  </btn>
  <btn size="lg"
       class="export-button"
       type="primary"
       @click="exportInfections('pneu')">
    Pneumopathies
  </btn>
  <save-blob :target="csv.target"></save-blob>
  <modal v-model="show"
         size="lg"
         :backdrop="false"
         :keyboard="false"
         :footer="false"
         :header="false">
    <div class="export-modal">
      <div class="row">
        <div class="col-xs-12">
          <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
        </div>
      </div>
      <div v-if="completed">
        <btn @click="hide" type="default">Retour</btn>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import stringify from 'csv-stringify'
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import saveBlob from '@/sui/components/saveblob'
import flatten from '@/sui/data/flatten/infections'

import moment from 'moment'

export default {
  name: 'infections-export',

  props: {
    year: {
      type: String,
      required: true
    },

    dataset: {
      type: String,
      required: true
    }
  },

  data: function () {
    const steps = [
      {
        title: 'Récupération des infections',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.error = null
            const instance = this
            var request = {
              y: parseInt(vm.year),
              inf: vm.infection,
              dset: vm.dataset
            }
            vm.$store.dispatch('infections/all', request).then(
              (response) => {
                if (response.data.err == null) {
                  data.full = Object.freeze(response.data.v)
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }
          return {
            end: data.full != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des infections : ${e}.`
        }
      },

      {
        title: 'Mise à plat des infections',
        index: 0,

        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.index = 0
            data.out = []
          }
          const max = data.full.length
          const step = 100
          const end = this.index + step >= max ? max : this.index + step
          for (let i = this.index; i !== end; ++i) {
            const s = data.full[i]
            data.out.push(
              flatten.createExportedInfections(s, vm.infection, vm.version)
            )
          }
          this.index = end

          return {
            end: this.index === max,
            success: true
          }
        },

        setError: function (e) {
          return `Erreur lors de la mise à plat des infections: ${e}.`
        }
      },

      {
        title: 'Export du fichier',
        end: false,
        success: false,

        run: function (vm, data, iteration) {
          const instance = this
          if (iteration === 0) {
            this.end = false
            this.success = false
            this.output = null
            var infectionsColumns = flatten.getInfectionsColumns(data.out)
            stringify(
              data.out,
              {
                header: true,
                bom: true,
                delimiter: ';',
                columns: infectionsColumns
              },
              function (err, output) {
                if (err != null) {
                  instance.end = true
                  instance.success = false
                  instance.errorDetail = err
                  instance.setError()
                } else {
                  instance.end = true
                  instance.success = true
                  instance.output = output
                }
              }
            )
          }

          if (this.end && this.success) {
            setTimeout(
              function () {
                const date = moment().format('DD-MM-YYYY-HH-mm-ss')
                vm.csv.target = {
                  filename: `${vm.dataset} - ${vm.infection} - ${date}.csv`,
                  blob: new Blob([instance.output], { type: 'text/plain' })
                }
              }, 10)
          }
          return {
            end: this.end,
            success: this.success,
            error: this.error
          }
        },
        setError: function (e) {
          return `Erreur lors de la création du fichier d'export: ${e}`
        }
      }
    ]
    return {
      infection: '',
      show: false,
      csv: {
        target: null
      },
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    },

    version: function () {
      return parseInt(this.year) - 2018
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    exportInfections: function (infct) {
      this.infection = infct
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'save-blob': saveBlob,
    'steps': stepsViewer
  }

}
</script>
<style scoped lang="less">
.export-infections-data {
  .export-button {
    margin: 0.3rem;
  }
}
</style>
